import React, { useEffect, useState, useCallback } from "react";
import LayoutV2 from "containers/LayoutV2";
import SearchForm from "./SearchForm";
import PhanTrang from "components/CommonComponent/PhanTrang";
import CongNoBanHangTable from "./CongNoBanHangTable";
import ModalThanhToan from "./ModalThanhToan";
import UserApi from "service/userApi";
import CongNoBanHangApi from "service/QuanLyMuaBan/CongNoBanHangApi";
import { formatDayMonth } from "utils/formatDate";
import { pushNotification } from "utils/notifications";

const CongNoBanHang = () => {
  const [hasPermission, setHasPermission] = useState(null);
  const [hasPermissionThanhToan, setHasPermissionThanhToan] = useState(null);
  const [ListData, setListData] = useState([]);
  const [Total, setTotal] = useState(0);
  const [Loading, setLoading] = useState(true);
  const [TotalAmount, setTotalAmount] = useState(0);
  const [TotalPaid, setTotalPaid] = useState(0);
  const [TotalSub, setTotalSub] = useState(0);
  const [showModalThanhToan, setShowModalThanhToan] = useState(false);
  const [editingOrderId, setEditingOrderId] = useState(0);

  const [dataSearch, setDataSearch] = useState({
    SearchText: "",
    DateFrom: null,
    DateTo: null,
    pageIndex: 1,
    pageSize: 25,
  });

  const fetchPermission = () => {
    setLoading(true);
    try {
      UserApi.getAllQuyen()
        .then((res) => {
          const detailedRoles = res.data.map((item) =>
            item.ModuleCode.toLowerCase(),
          );
          const hasPageAccess = detailedRoles.includes("quanlycongnobanhang");
          const hasThanhToanAccess = detailedRoles.includes(
            "congnobanhang_thanhtoan",
          );
          setHasPermission(hasPageAccess);
          setHasPermissionThanhToan(hasThanhToanAccess);
        })
        .catch((err) => {
          setHasPermission(false);
          setHasPermissionThanhToan(false);
        });
    } catch (err) {
      setHasPermission(false);
      setHasPermissionThanhToan(false);
    }
  };

  const LoadDanhSach = useCallback((searchData, page) => {
    setLoading(true);
    const payload = {
      ...searchData,
      DateFrom: searchData.DateFrom ? formatDayMonth(searchData.DateFrom) : "",
      DateTo: searchData.DateTo ? formatDayMonth(searchData.DateTo) : "",
      pageIndex: page,
    };

    CongNoBanHangApi.getData(payload)
      .then((res) => {
        if (res.status === 200) {
          const data = res.data || {};
          setListData(data.List || []);
          setTotal(data.TotalRecords || 0);
          setTotalAmount(data.TotalAmount || 0);
          setTotalPaid(data.TotalPaid || 0);
          setTotalSub(data.TotalSub || 0);
          setDataSearch((prev) => ({ ...prev, pageIndex: page }));
        } else {
          pushNotification("Load danh sách thất bại!", "error");
        }
      })
      .catch((error) => pushNotification("Có lỗi khi gọi Api!", "error"))
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    document.title = "Công nợ bán hàng | Phần mềm quản lý cầm đồ Morman";
    fetchPermission();
  }, []);

  useEffect(() => {
    if (hasPermission) {
      LoadDanhSach(dataSearch, 1);
    }
  }, [hasPermission]);

  const onChangeData = (field) => (event) => {
    const value = event?.target?.value ?? event?.value ?? "";
    setDataSearch((prev) => ({ ...prev, [field]: value }));
  };
  const onChangeDate = (field) => (value) => {
    setDataSearch((prev) => ({ ...prev, [field]: value }));
  };
  const handlePageChange = (pageNumber) => {
    LoadDanhSach(dataSearch, pageNumber);
  };
  const handlePageSizeChange = (pageSize) => {
    const data = { ...dataSearch, pageSize, pageIndex: 1 };
    setDataSearch(data);
    LoadDanhSach(data, 1);
  };
  const onSearch = () => {
    LoadDanhSach(dataSearch, 1);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      LoadDanhSach(dataSearch, 1);
    }
  };

  const handleThanhToanClick = (orderId) => {
    setEditingOrderId(orderId);
    setShowModalThanhToan(true);
  };

  const onCloseThanhToanModal = (isSuccess) => {
    setShowModalThanhToan(false);
    setEditingOrderId(0);
    if (isSuccess === true) {
      onSearch();
    }
  };

  if (hasPermission === false) {
    return (
      <LayoutV2>
        <h2 className="text-danger text-center mt-5">
          Bạn không có quyền truy cập trang này!
        </h2>
      </LayoutV2>
    );
  }
  return (
    <>
      <LayoutV2>
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div className="row header">
                          <img
                            src="/app-assets/images/logo-quan-ly-mua-ban-nhap-hang-v2.png"
                            alt="logo"
                          />
                          <h1
                            className="text-info-home"
                            style={{ fontSize: 25 }}
                          >
                            Quản lý mua bán - Công nợ bán hàng
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-1 show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <SearchForm
                      dataSearch={dataSearch}
                      onChangeData={onChangeData}
                      onChangeDate={onChangeDate}
                      onSearch={onSearch}
                      handleKeyDown={handleKeyDown}
                    />
                  </div>
                </div>
                {Loading && (
                  <div className="loader loader-default is-active"></div>
                )}
                {!Loading && hasPermission && (
                  <>
                    <div
                      className="card border-light mb-1 card-v2"
                      style={{ marginTop: "0px" }}
                    >
                      <div
                        className="card-body card-body-v2"
                        style={{ userSelect: "text" }}
                      >
                        <CongNoBanHangTable
                          list={ListData}
                          Total={Total}
                          TotalAmount={TotalAmount}
                          TotalPaid={TotalPaid}
                          TotalSub={TotalSub}
                          onThanhToanClick={handleThanhToanClick}
                          hasThanhToanAccess={hasPermissionThanhToan}
                          pageIndex={dataSearch.pageIndex}
                          pageSize={dataSearch.pageSize}
                        />
                      </div>
                      <div
                        className="card border-light mb-1 card-v2"
                        style={{
                          marginLeft: "15px",
                          marginRight: "15px",
                          marginTop: "15px",
                        }}
                      >
                        <div
                          className="card-body card-body-v2"
                          style={{ display: Total === 0 ? "none" : "block" }}
                        >
                          <PhanTrang
                            pageIndex={dataSearch.pageIndex}
                            pageSize={dataSearch.pageSize}
                            totalCount={Total}
                            onPageChange={handlePageChange}
                            onPageSizeChange={handlePageSizeChange}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </LayoutV2>
      {showModalThanhToan && (
        <ModalThanhToan
          orderId={editingOrderId}
          onClose={onCloseThanhToanModal}
        />
      )}
    </>
  );
};
export default CongNoBanHang;
